<div class="custom-field-form">
  <div class="p-5">
    <div class="d-flex justify-content-between">
      <div class="align-self-center">
        <h3 class="mt-4 inline">
          {{ !customFieldId ? 'Create' : 'Update' }} Custom Field
        </h3>
      </div>
      <div class="align-self-center">
        <button
          *ngIf="!isDialog"
          type="button"
          class="lum-button lum-button--secondary"
          mat-button
          [routerLink]="['/custom-fields']"
        >
          <lum-ui-icon
            icon="chevron-left-circle"
            [width]="24"
            [height]="24"
            color="#5563d6"
          ></lum-ui-icon>
          Go Back To Custom Fields
        </button>

        <button
          *ngIf="isDialog"
          type="button"
          class="lum-button lum-button--secondary"
          mat-button
          (click)="dialogRef.close()"
        >
          <lum-ui-icon
            class="mr-2-5"
            icon="close-circle"
            color="#5563D6"
            width="23"
            height="23"
          ></lum-ui-icon>
          Close
        </button>
      </div>
    </div>
    <mat-divider class="my-2"></mat-divider>
  </div>

  <mat-card class="lum-mat-card" *ngIf="!isDialog">
    <mat-card-content>
      <ng-container *ngTemplateOutlet="customFieldForm"></ng-container>
    </mat-card-content>
  </mat-card>

  <ng-container *ngIf="isDialog">
    <ng-container *ngTemplateOutlet="customFieldForm"></ng-container>
  </ng-container>
</div>

<ng-template #customFieldForm>
  <form [formGroup]="form">
    <div class="p-5">
      <div class="lum-c-custom-field-form__row d-flex align-items-start mb-4">
        <div class="lum-c-custom-field-form__left">
          <div class="form-group">
            <label class="lum-c-custom-field-form__label">Label</label>
            <input
              formControlName="label"
              type="text"
              required="true"
              class="lum-input"
            />
            <mat-error *ngIf="form.get('label')?.invalid">
              {{ form.get('label') | validateField }}
            </mat-error>
          </div>
          <div class="form-group">
            <label class="lum-c-custom-field-form__label">Type</label>
            <mat-select class="lum-select" formControlName="type">
              <mat-option
                *ngFor="
                  let customFieldType of customFieldTypes;
                  trackBy: trackByValue
                "
                [value]="customFieldType"
              >
                {{ customFieldType }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="form.get('type')?.invalid">
              {{ form.get('type') | validateField }}
            </mat-error>
          </div>
        </div>
        <div class="lum-c-custom-field-form__objects-col">
          <div class="form-group">
            <label class="lum-c-custom-field-form__label">Custom Field Objects</label>
            <div
              formArrayName="customFieldObjectTypes"
              class="custom-field-objects-list lum-c-custom-field-form__objects-list--spaced"
            >
              <mat-checkbox
                *ngFor="let obj of availableCustomFieldObjects; let i = index; trackBy: trackByValue"
                [formControlName]="i"
                color="primary"
                class="lum-c-custom-field-form__checkbox"
              >
                {{ obj.label }}
              </mat-checkbox>
            </div>
            <mat-error *ngIf="form.get('customFieldObjectTypes')?.invalid && (form.get('customFieldObjectTypes')?.touched || form.get('customFieldObjectTypes')?.dirty)">
              Select at least one object for this custom field
            </mat-error>
          </div>
        </div>
      </div>

      <ng-container
        *ngIf="form.get('type')?.value === eCustomFieldType.DROPDOWN"
        formArrayName="options"
      >
        <div class="row flex align-items-center mb-4">
          <div class="col-auto">
            <label>Options</label>
          </div>
          <div class="col-auto">
            <button
              type="button"
              class="lum-button lum-button--secondary lum-button--small"
              (click)="addDropdownOption()"
            >
              <lum-ui-icon
                icon="plus-circle"
                [width]="24"
                [height]="24"
                color="#5563d6"
              ></lum-ui-icon>
              Add Option
            </button>
          </div>
        </div>

        <div
          class="row mb-4"
          *ngFor="
            let option of optionsControls;
            trackBy: trackByControlValue;
            let i = index
          "
        >
          <div>
            <div class="input-group">
              <input
                [formControlName]="i"
                type="text"
                required="true"
                class="form-control"
              />
              <div class="input-group-append">
                <button
                  type="button"
                  class="btn btn-outline-secondary"
                  (click)="removeDropdownOption(i)"
                >
                  <lum-ui-icon
                    icon="minus-circle"
                    [width]="24"
                    [height]="24"
                    color="#5563d6"
                  ></lum-ui-icon>
                  Remove Option
                </button>
              </div>
            </div>
            <mat-error *ngIf="option.invalid">
              {{ option | validateField }}
            </mat-error>
          </div>
        </div>
      </ng-container>

      <div class="d-flex justify-content-end">
        <lum-ui-button [loading]="submittingForm" (clickEvent)="onSubmit()">
          Save
          <lum-ui-icon class="ml-2-5" icon="content-save"></lum-ui-icon>
        </lum-ui-button>
      </div>
    </div>
  </form>
</ng-template>
